import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import OurMission from "./sections/OurMission";
import CoreServicesOverview from "./sections/CoreServicesOverview";
import MeasurableOutcomes from "./sections/MeasurableOutcomes";
import WhatParentsSay from "./sections/WhatParentsSay";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <OurMission />
      <CoreServicesOverview />
      <MeasurableOutcomes />
      <WhatParentsSay />
      <Footer />
    </div>;
}